// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* A4 Portrait simulation for MuiMarkdown */
.a4-document .MuiTypography-root {
  font-family: 'Roboto', 'Times New Roman', serif;
}

.a4-document.with-margins {
  /* Page break lines - repeating dotted lines every A4 height */
  background-image: 
    repeating-linear-gradient(
      #ddd,
      #ddd 12mm,
      transparent calc(12mm + 1px),
      transparent calc(285mm - 1px), /* 297mm - 8mm top/bottom margins */
      #ddd calc(285mm),
      #ddd 297mm
    );
  background-size: 100% 297mm;
  background-repeat: repeat-y;
}

.a4-document {
  /* display: flex; */
  /* position: relative; */
  /* A4 dimensions: 210mm x 297mm */
  width: 210mm;
  min-height: 297mm;
  
  /* Alternative pixel-based approach (96 DPI) */
  /* width: 794px; */
  /* height: 1123px; */
  
  /* Document styling */
  background: white;
  padding: 12mm; /* 1/4" margins all around */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  
  /* Typography for document feel */
  font-family: 'Roboto', 'Times New Roman', serif;
  font-size: 12pt;
  line-height: 1.6;
  color: #333;
  
  /* Ensure proper page breaks for printing */
  page-break-after: always;
  
  /* Prevent content overflow */
  box-sizing: border-box;
  /* overflow: hidden; */
}

/* Container to center the document */
.document-container {
  display: flex;
  position: relative;
  justify-content: center;
  min-height: fit-content;
  height: fit-content;
  background-color: #f5f5f5; /* Light gray background for contrast */
  padding: 20px 0;
}

/* Responsive adjustments */
@media screen and (max-width: 900px) {
  .a4-document {
    width: 95vw;
    height: auto;
    min-height: 134vw; /* Maintains A4 aspect ratio (297/210 ≈ 1.414) */
    margin: 10px auto;
    padding: 6vw;
  }
}

/* Print styles */
@media print {
  .document-container {
    background: none;
    padding: 0mm !important;
    margin: 0mm !important;
  }
  
  .a4-document {
    width: 210mm;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    page-break-after: always;
  }
}

/* Additional MuiMarkdown specific adjustments */
.a4-document h1,
.a4-document h2,
.a4-document h3,
.a4-document h4,
.a4-document h5,
.a4-document h6 {
  font-size: 1em;
  margin-top: 0.25em;
  margin-bottom: 0.25em;
}

/* Put after above so they take precedence */
.a4-document h1,
.a4-document h2 {
  font-size: 1.1em;
}


.a4-document p {
  margin-bottom: 1em;
  text-align: justify;
}

.a4-document ul,
.a4-document ol {
  margin-bottom: 1em;
  padding-left: 2em;
}

.a4-document blockquote {
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid #ccc;
  font-style: italic;
}

.a4-document code {
  background-color: #f5f5f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

.a4-document pre {
  background-color: #f5f5f5;
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
  margin: 1em 0;
}

.BackstoryResumeHeader {
  gap: 1rem;
  display: flex;
  /* flex-direction: column; */
}

.BackstoryResumeHeader p {
  /* border: 3px solid purple; */
  margin: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/ui/ResumePreview.css"],"names":[],"mappings":";AACA,2CAA2C;AAC3C;EACE,+CAA+C;AACjD;;AAEA;EACE,8DAA8D;EAC9D;;;;;;;;KAQG;EACH,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;;EAEjB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;;EAEpB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa,EAAE,4BAA4B;EAC3C,wCAAwC;EACxC,yBAAyB;;EAEzB,iCAAiC;EACjC,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,2CAA2C;EAC3C,wBAAwB;;EAExB,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB,EAAE,uCAAuC;EAClE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,gDAAgD;IACnE,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA,gDAAgD;AAChD;;;;;;EAME,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;;EAEE,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB","sourcesContent":["\n/* A4 Portrait simulation for MuiMarkdown */\n.a4-document .MuiTypography-root {\n  font-family: 'Roboto', 'Times New Roman', serif;\n}\n\n.a4-document.with-margins {\n  /* Page break lines - repeating dotted lines every A4 height */\n  background-image: \n    repeating-linear-gradient(\n      #ddd,\n      #ddd 12mm,\n      transparent calc(12mm + 1px),\n      transparent calc(285mm - 1px), /* 297mm - 8mm top/bottom margins */\n      #ddd calc(285mm),\n      #ddd 297mm\n    );\n  background-size: 100% 297mm;\n  background-repeat: repeat-y;\n}\n\n.a4-document {\n  /* display: flex; */\n  /* position: relative; */\n  /* A4 dimensions: 210mm x 297mm */\n  width: 210mm;\n  min-height: 297mm;\n  \n  /* Alternative pixel-based approach (96 DPI) */\n  /* width: 794px; */\n  /* height: 1123px; */\n  \n  /* Document styling */\n  background: white;\n  padding: 12mm; /* 1/4\" margins all around */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e0e0;\n  \n  /* Typography for document feel */\n  font-family: 'Roboto', 'Times New Roman', serif;\n  font-size: 12pt;\n  line-height: 1.6;\n  color: #333;\n  \n  /* Ensure proper page breaks for printing */\n  page-break-after: always;\n  \n  /* Prevent content overflow */\n  box-sizing: border-box;\n  /* overflow: hidden; */\n}\n\n/* Container to center the document */\n.document-container {\n  display: flex;\n  position: relative;\n  justify-content: center;\n  min-height: fit-content;\n  height: fit-content;\n  background-color: #f5f5f5; /* Light gray background for contrast */\n  padding: 20px 0;\n}\n\n/* Responsive adjustments */\n@media screen and (max-width: 900px) {\n  .a4-document {\n    width: 95vw;\n    height: auto;\n    min-height: 134vw; /* Maintains A4 aspect ratio (297/210 ≈ 1.414) */\n    margin: 10px auto;\n    padding: 6vw;\n  }\n}\n\n/* Print styles */\n@media print {\n  .document-container {\n    background: none;\n    padding: 0mm !important;\n    margin: 0mm !important;\n  }\n  \n  .a4-document {\n    width: 210mm;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    border: none;\n    page-break-after: always;\n  }\n}\n\n/* Additional MuiMarkdown specific adjustments */\n.a4-document h1,\n.a4-document h2,\n.a4-document h3,\n.a4-document h4,\n.a4-document h5,\n.a4-document h6 {\n  font-size: 1em;\n  margin-top: 0.25em;\n  margin-bottom: 0.25em;\n}\n\n/* Put after above so they take precedence */\n.a4-document h1,\n.a4-document h2 {\n  font-size: 1.1em;\n}\n\n\n.a4-document p {\n  margin-bottom: 1em;\n  text-align: justify;\n}\n\n.a4-document ul,\n.a4-document ol {\n  margin-bottom: 1em;\n  padding-left: 2em;\n}\n\n.a4-document blockquote {\n  margin: 1em 0;\n  padding-left: 1em;\n  border-left: 3px solid #ccc;\n  font-style: italic;\n}\n\n.a4-document code {\n  background-color: #f5f5f5;\n  padding: 0.2em 0.4em;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n}\n\n.a4-document pre {\n  background-color: #f5f5f5;\n  padding: 1em;\n  border-radius: 5px;\n  overflow-x: auto;\n  margin: 1em 0;\n}\n\n.BackstoryResumeHeader {\n  gap: 1rem;\n  display: flex;\n  /* flex-direction: column; */\n}\n\n.BackstoryResumeHeader p {\n  /* border: 3px solid purple; */\n  margin: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
